import { apiConfig } from '../../../common/apiConfig'
import { createUserStore } from '../../../common/user/createUserStore'
import {
  OfficeProfileApi,
  SignOutRequestRoleEnum,
  UserSessionsApi,
  UserSignInRequestRoleEnum,
} from '../../../generated'

const api = new OfficeProfileApi(apiConfig)
const sapi = new UserSessionsApi(apiConfig)

const _load = api.currentOfficeProfile.bind(api)

async function _signIn(account: string, password: string, keep: boolean) {
  return sapi.userSignIn({ account, password, keep, role: UserSignInRequestRoleEnum.Office })
}

async function _signOut() {
  return sapi.userSignOut({ role: SignOutRequestRoleEnum.Office })
}

export const { signOut, onSignOut, onError, useUser } = createUserStore(_load, _signIn, _signOut)
